import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "@/components/feature/SectionHeading";

export default function NewsPreview() {
  const featured = newsList[0];
  const rest = newsList.slice(1, 6);

  return (
    <section className="mx-auto max-w-[1280px] px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        title="最新动漫资讯"
        subtitle="权威及时的动画新闻、行业动态与专题报道"
        icon="ri-newspaper-line"
        moreTo="/news"
        moreLabel="全部资讯"
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <Link
          to={`/news/${featured.id}`}
          className="group relative rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all"
        >
          <div className="relative w-full h-56 md:h-72 overflow-hidden bg-background-200">
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} - 动漫资讯`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
              {featured.category}
            </span>
          </div>
          <div className="p-4 md:p-5">
            <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950 group-hover:text-primary-600 transition-colors clamp-2">
              {featured.title}
            </h3>
            <p className="text-sm text-foreground-600 mt-2.5 clamp-2 leading-relaxed">{featured.summary}</p>
            <div className="flex items-center gap-4 mt-4 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-calendar-line" />{featured.publishedAt}</span>
              <span className="flex items-center gap-1"><i className="ri-eye-line" />{featured.views.toLocaleString()}</span>
            </div>
          </div>
        </Link>

        <div className="flex flex-col gap-3">
          {rest.map((news) => (
            <Link
              key={news.id}
              to={`/news/${news.id}`}
              className="group flex items-center gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all"
            >
              <div className="w-24 h-20 md:w-28 md:h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
                <img
                  src={news.cover}
                  alt={news.title}
                  title={`${news.title} - 动漫资讯`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors clamp-2 leading-snug">
                  {news.title}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">{news.category}</span>
                  <span className="flex items-center gap-1"><i className="ri-calendar-line" />{news.publishedAt}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}